var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronsDownDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,15.8c-0.2,0-0.4-0.1-0.5-0.2l-4.2-4.2c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l3.6,3.6l3.6-3.6 c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1l-4.2,4.2C10.4,15.7,10.2,15.8,10,15.8z M10.5,9.7l4.2-4.2c0.3-0.3,0.3-0.8,0-1.1 s-0.8-0.3-1.1,0L10,8.1L6.4,4.5c-0.3-0.3-0.8-0.3-1.1,0S5,5.2,5.3,5.5l4.2,4.2C9.6,9.8,9.8,9.9,10,9.9C10.2,9.9,10.4,9.8,10.5,9.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsDownDouble);
export default __webpack_public_path__ + "static/media/chevrons-down-double.fbb8330948fca9d2e8ddbed2490187cb.svg";
export { ForwardRef as ReactComponent };